import { render, staticRenderFns } from "./ContributorsView.vue?vue&type=template&id=3e41437a"
import script from "./ContributorsView.vue?vue&type=script&lang=js"
export * from "./ContributorsView.vue?vue&type=script&lang=js"
import style0 from "./ContributorsView.vue?vue&type=style&index=0&id=3e41437a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports